import { render, staticRenderFns } from "./ListCargaView.vue?vue&type=template&id=0b45e74c&"
import script from "./ListCargaView.vue?vue&type=script&lang=ts&"
export * from "./ListCargaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports